import { render, staticRenderFns } from "./OrganizationsGrid.vue?vue&type=template&id=58a004b3&scoped=true&"
import script from "./OrganizationsGrid.vue?vue&type=script&lang=js&"
export * from "./OrganizationsGrid.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationsGrid.vue?vue&type=style&index=0&id=58a004b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a004b3",
  null
  
)

export default component.exports